export default __webpack_public_path__ + "static/media/Layout t2 - Segregação Arm. 01 rev 24.f152d1b1.pdf";